import React from 'react'

const Loader = () => {
  return (
    <>
    <div className="fixed  z-50 inset-0 flex justify-center items-center bg-black bg-opacity-50">
    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-customGreen"></div>
  </div>
  </>

  )
}

export default Loader
